var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.39217 0.639783L0.171555 11.4134C0.0591886 11.608 2.07966e-05 11.8287 5.48127e-09 12.0534C-2.07856e-05 12.278 0.0591062 12.4988 0.171436 12.6933C0.283767 12.8879 0.445341 13.0495 0.639917 13.1618C0.834493 13.2742 1.05521 13.3333 1.27989 13.3333H13.7201C13.9448 13.3333 14.1655 13.2742 14.3601 13.1618C14.5547 13.0495 14.7162 12.8879 14.8286 12.6933C14.9409 12.4988 15 12.278 15 12.0534C15 11.8287 14.9408 11.608 14.8284 11.4134L8.6085 0.639783C8.49619 0.445264 8.33465 0.283734 8.14013 0.171429C7.94561 0.0591237 7.72495 0 7.50033 0C7.27572 0 7.05506 0.0591237 6.86054 0.171429C6.66602 0.283734 6.50448 0.445264 6.39217 0.639783Z",
    fill: "#EE404C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.58094 3.96259H7.41867C7.01917 3.96259 6.69531 4.28645 6.69531 4.68595V8.1435C6.69531 8.543 7.01917 8.86686 7.41867 8.86686H7.58094C7.98044 8.86686 8.30431 8.543 8.30431 8.1435V4.68595C8.30431 4.28645 7.98044 3.96259 7.58094 3.96259Z",
    fill: "#FFF7ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.49981 11.6091C7.94412 11.6091 8.30431 11.2489 8.30431 10.8046C8.30431 10.3602 7.94412 10.0001 7.49981 10.0001C7.0555 10.0001 6.69531 10.3602 6.69531 10.8046C6.69531 11.2489 7.0555 11.6091 7.49981 11.6091Z",
    fill: "#FFF7ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.e1aa35fca2395c5adbe36702ae4b16b4.svg";
export { ForwardRef as ReactComponent };